/** Maximum number of lists a teacher can save in the rules library. */
export const MAX_LISTS = 30;

/** Maximum number of rules allowed in a single list. */
export const MAX_RULES_PER_LIST = 200;

/** Maximum number of active rules in a class (in-class, app controls, and applied list rules). */
export const MAX_ACTIVE_RULES = 200;

/** Maximum number of characters allowed for a list name. */
export const MAX_LIST_NAME_LENGTH = 30;

/** Stored name used to find the shared Quick Block list until the API flags it. */
export const QUICK_BLOCK_LIST_NAME = "Quick Block: Category Rules";

/** Help article listing Windows apps that Classwize can control. */
export const WINDOWS_APP_LIST_URL = "https://help.classwize.net/hc/en-gb/articles/8675151325212";

/** Signatures that must never appear as selectable rule targets. */
export const EXCLUDED_SIGNATURE_IDS = new Set([
	"sphirewall.application.porn",
	"sphirewall.application.childporn",
	"sphirewall.application.offensive",
]);

export const LOCKED_RULE_CONFLICT_CODE = "LOCKED_RULE_CONFLICT";
export const LOCKED_RULE_DUPLICATE_CODE = "LOCKED_RULE_DUPLICATE";

export const LOCKED_RULE_WARNING_CODES = new Set([LOCKED_RULE_CONFLICT_CODE, LOCKED_RULE_DUPLICATE_CODE]);
